@use "../../../../../../styles/Colors.scss" as Colors;
@use "../../../../../../styles/Constants.scss" as Constants;

.JobMaterialsTable {

	.tableHeader {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		padding: Constants.$val-spacing-s Constants.$val-spacing-l;

		.filters {
			flex: 0;
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: flex-start;
		}

		.actions {
			flex: 1;
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: flex-end;

			.action {
				margin-left: Constants.$val-spacing-s;
			}
		}
	}

	.bottomElement {
		height: Constants.$val-spacing-xxxl;
	}

	.loadingText {
		text-align: center;
		font-size: Constants.$val-fontSizeBig;
		padding-bottom: Constants.$val-spacing-xxxl;
		padding-top: Constants.$val-spacing-m;
	}

	.importInstructions {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: Constants.$val-spacing-l;

		.instructions {
			font-size: Constants.$val-fontSizeRegular;
			line-height: Constants.$val-lineHeightRegular;
			color: Colors.$col-design-grey10;
			margin-bottom: Constants.$val-spacing-m;
		}
	}
}
